import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "../../../ui/dropdown-menu";
import { FooterItemType } from "../types";

export const FooterItem = ({
  footer,
}: {
  footer: FooterItemType | undefined;
}) => {
  if (!footer) {
    return null;
  }
  return (
    <>
      <DropdownMenuSeparator className="bg-purple-muted-500" />
      <DropdownMenuItem
        onClick={footer.action}
        disabled={footer.disabled}
        className="cursor-pointer m-0 rounded-none py-1.5 px-3 text-purple-300 focus:bg-transparent"
      >
        {footer.icon}
        {footer.label}
      </DropdownMenuItem>
    </>
  );
};
